import Icon from '../components/Icon.vue'

Icon.register({"quote-left":{"width":512,"height":512,"paths":[{"d":"M464 256H384V192C384 156.7 412.7 128 448 128H456C469.3 128 480 117.3 480 104V56C480 42.7 469.3 32 456 32H448C359.6 32 288 103.6 288 192V432C288 458.5 309.5 480 336 480H464C490.5 480 512 458.5 512 432V304C512 277.5 490.5 256 464 256zM176 256H96V192C96 156.7 124.7 128 160 128H168C181.3 128 192 117.3 192 104V56C192 42.7 181.3 32 168 32H160C71.6 32 0 103.6 0 192V432C0 458.5 21.5 480 48 480H176C202.5 480 224 458.5 224 432V304C224 277.5 202.5 256 176 256z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/quote-left.js
// module id = null
// module chunks = 